export default __webpack_public_path__ + "affc873776d4e849a7ea296460ffa0f0.png";